



















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class ReviewStatusView extends Vue {
  @Prop() private status!: number;
}
